import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Icon,
  Tooltip,
  Button,
  CircularProgress
} from "@material-ui/core";

function isEmptyOrSpaces(str) {
  return (
    str === undefined || str === null || str.toString().match(/^ *$/) !== null
  );
}

const AssignedTodoCard = props => {
  return (
    <Card>
      <Grid container>
        <Grid
          item
          xs={9}
          sm={9}
          md={10}
          style={{ borderRight: "1px solid #cccccc69" }}
        >
          <CardContent>
            <Typography variant="subheading">{props.title}</Typography>
            <div
              style={{
                borderBottom: "1px solid #cccccc69",
                margin: "5px auto",
                width: "100%"
              }}
            />
            <Typography variant="body2" className="todoDesc">
              {props.desc}
            </Typography>
            <div
              style={{
                borderBottom: "1px solid #cccccc69",
                margin: "5px auto",
                width: "100%"
              }}
            />
            <Typography variant="caption">
              Created: {props.date_created}
            </Typography>
            {props.due_date ? (
							<Typography variant="caption">
								Due: {props.due_date}
							</Typography>
						) : null}
            <Typography variant="caption" style={{ marginTop: "15px" }}>
              <strong>Assigned To:</strong> You
            </Typography>
            <Typography variant="caption">
              <strong>From:</strong>{" "}
              {props.from_user}
            </Typography>
            <Typography variant="caption">
              <strong>Client:</strong>{" "}
              {!isEmptyOrSpaces(props.client_fullname)
                ? props.client_fullname
                : "None"}
            </Typography>
          </CardContent>
        </Grid>
        <Grid item xs={3} sm={3} md={2} style={{ textAlign: "center" }}>
          {props.loadingAction ? (
            <div style={{ marginTop: "10px" }}>
              <CircularProgress size={20} />
            </div>
          ) : (
            <Grid container>
              <Grid item xs={12} sm={12} md={12} style={{ marginTop: "10px" }}>
                <Tooltip title="Mark as done">
                  <Button
                    variant="fab"
                    mini
                    color="secondary"
                    aria-label="Edit"
                    className="semiSmallFab"
                    onClick={props.doneToggle}
                  >
                    <Icon style={{ color: "white" }}>check</Icon>
                  </Button>
                </Tooltip>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};

export default AssignedTodoCard;



// WEBPACK FOOTER //
// ./src/views/Todos/components/AssignedTodoCard.jsx